import React from 'react'
import Card from '../../../../molecules/Card'
import ContentThingsTool from './Things'
const ContentTab = () => {
  return (
    <Card variant='clear'>
      <ContentThingsTool />
    </Card>
  )
}

export default ContentTab
